import React from "react";
import {Navigate} from "react-router";
import {useAppContext} from "../libs/ContextLibs";
import {querystring} from "./Util";


export default function UnauthenticatedRoute({children}) {
    const {isAuthenticated} = useAppContext();
    const redirect = querystring("redirect");

    return !isAuthenticated ? (
        children
    ) : (
        <Navigate to={redirect === "" || redirect === null ? "/" : redirect} replace />
    );
}